export const getColumnsVisibleStorage = () => {
  const columnsVisible = sessionStorage.getItem('columns-visible');
  if (!columnsVisible) {
    return {
      username: true,
      role: true,
      firstName: true,
      lastName: true,
      institution: true,
      organization: true,
      lastActive: true,
      status: true,
    };
  }
  return JSON.parse(columnsVisible);
};

export const setColumnsVisibleStorage = (columnsVisible) => {
  sessionStorage.setItem('columns-visible', JSON.stringify(columnsVisible));
};
